module.exports = __webpack_public_path__ + "img/booker.8772d2c5.png";